import { EstadoVazio } from '../../components/Estados'
import { TEXTOS } from '../../lib/glossario'
import type { AtividadeDoMes } from '../../types/repositorios'
import { AreasMaisTocadas } from './AreasMaisTocadas'
import { ArquivosMaisTocados } from './ArquivosMaisTocados'

/**
 * A seção "O que foi modificado": áreas e arquivos mais tocados, lado a lado.
 *
 * Quando não há arquivo detalhado o estado vazio explica quantos commits ainda não tiveram os
 * arquivos lidos — a coleta busca o detalhe numa segunda passada, e um mês recém-coletado passa
 * por um intervalo em que os números existem e os arquivos ainda não.
 *
 * @param props a atividade do mês
 * @returns a seção
 */
export function OQueFoiModificado({ dados }: { dados: AtividadeDoMes }) {
  const t = TEXTOS.repositorios
  const vazio = dados.areasMaisTocadas.length === 0 && dados.arquivosMaisTocados.length === 0

  return (
    <section className="cartao space-y-4 p-4" aria-label={t.secoes.modificado}>
      <header>
        <h2 className="text-base font-semibold text-slate-900">{t.secoes.modificado}</h2>
        <p className="mt-1 max-w-prose text-sm text-slate-500">{t.modificado.ajuda}</p>
      </header>
      {vazio ? (
        <EstadoVazio titulo={t.modificado.semDetalhe.titulo} ajuda={t.modificado.semDetalhe.ajuda(dados.numeros?.semDetalhe ?? 0)} />
      ) : (
        <div className="grid gap-6 xl:grid-cols-2">
          <AreasMaisTocadas areas={dados.areasMaisTocadas} />
          <ArquivosMaisTocados arquivos={dados.arquivosMaisTocados} />
        </div>
      )}
    </section>
  )
}
